import React, { Fragment } from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import PanelDePestania from 'components/Pestanias/PanelDePestania';
import PestaniasDesplazables from 'components/Pestanias';
import TituloConIcono from 'components/tituloConIcono';
import { LibraryBooks } from '@mui/icons-material';
import DetalleDelMedio from './DatosDelMedio';
import DetalleDeLaCobertura from './DetalleCobertura';

const DetalleDeLaEmpresa = ({title, openFullScreenDialog, handleClose, datosDelMedio, datosDeLasEmpresas, datosGeneralesDelTarifario, tipoDelMedio}) => {
    const dataTabs = [
        {label: "Datos del medio y demograficos", icon: <LibraryBooks />, position: 0},
        {label:  `${datosDelMedio?.cobertura?.descripcion || "Cobertura"}`, icon: <LibraryBooks />, position: 1},
        // {label: "Tarifario y Disponibilidad", icon: <LibraryBooks />, position: 1},
    ];
    const [value, setValue] = React.useState(0);

    const handleChange = (_, newValue) => { setValue(newValue) };

    const closeFullScreenForm = function() { handleClose() }

    // console.log("datosDelMedio", datosDelMedio)
    // console.log("datosDeLasEmpresas", datosDeLasEmpresas)

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={closeFullScreenForm}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                <TituloConIcono title={`Detalle del medio ${datosDelMedio?.tipoDeMedioDeComunicacion?.descripcion?.toLowerCase() || "" } registrado`} mostrarTiempo={false} mostrarBotones={false} showDivider={false} icon="television" />
                <PestaniasDesplazables
                    handleChange={handleChange}
                    value={value}
                    tabs={dataTabs}
                >
                    <PanelDePestania value={value} index={0}>
                        <DetalleDelMedio datosDelMedio={datosDelMedio} datosDeLasEmpresas={datosDeLasEmpresas} datosGeneralesDelTarifario={datosGeneralesDelTarifario} tipoDelMedio={tipoDelMedio} />
                    </PanelDePestania>
                    <PanelDePestania value={value} index={1}>
                        <DetalleDeLaCobertura datosGeneralesDelTarifario={datosGeneralesDelTarifario} />
                    </PanelDePestania>
                    <PanelDePestania value={value} index={2}>
                        {/* <DetalleDelTarifarioYDisponibilidad datosDelMedio={datosDelMedio} tipoDelMedio={tipoDelMedio} mostrarDetalleDelCanal={mostrarDetalleDelCanal} /> */}
                    </PanelDePestania>
                </PestaniasDesplazables>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default DetalleDeLaEmpresa;